import { Component, DestroyRef, inject, NgZone, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import {
  SiSelectComponent,
  SiSelectLazyOptionsDirective,
  SiSelectSingleValueDirective
} from '@siemens/element-ng/select';
import * as L from 'leaflet';

import { GeocodedPlace, PlaceSelectSource } from './place-select-source';

export interface MapSearchResult {
  name: string;
  center: L.LatLng;
  bbox: L.LatLngBounds;
}

/**
 * Place search, replacing the legacy `plugin/Search.js` geocoder control.
 *
 * Uses the same `si-select` autocomplete as the route planner's station search, so both
 * inputs look and behave the same.
 */
@Component({
  selector: 'app-map-search',
  imports: [
    FormsModule,
    TranslateModule,
    SiSelectComponent,
    SiSelectSingleValueDirective,
    SiSelectLazyOptionsDirective
  ],
  templateUrl: './map-search.component.html'
})
export class MapSearchComponent {
  readonly resultSelected = output<MapSearchResult>();

  readonly placeSource = new PlaceSelectSource(inject(NgZone));
  readonly selectedPlaceId = signal<string | undefined>(undefined);

  constructor() {
    inject(DestroyRef).onDestroy(() => this.placeSource.cleanup());
  }

  onPlaceChange(placeId: string | undefined): void {
    if (!placeId) {
      return;
    }

    const place: GeocodedPlace | undefined = this.placeSource.getPlaceById(placeId);
    if (!place) {
      return;
    }

    this.selectedPlaceId.set(placeId);
    this.resultSelected.emit({ name: place.name, center: place.center, bbox: place.bbox });
  }
}
